<div>
  <div class="search-container">
    <form [formGroup]="searchTemplateForm" autocomplete="off">
      <div>
        <mat-form-field appearance="outline" hideRequiredMarker="true">
          <mat-label i18n="@@searchPromptTemplates"
            >Search prompt templates</mat-label
          >
          <input
            matInput
            type="text"
            formControlName="filter"
            placeholder="Search prompt templates"
            i18n-placeholder="@@searchPromptTemplatesPlaceholder"
          />
          <mat-icon class="search-icon-wrapper" matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      @if(isDesktopView){
      <div class="chip-list-container">
        <mat-chip-listbox
          selectable="true"
          multiple="false"
          [formControl]="chipListControl"
        >
          @for (chipItem of chipListItems; track chipItem) {
          <mat-chip-option [value]="chipItem">
            {{ chipItem }}
          </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
      }
    </form>
  </div>
  <div class="prompt-grid-container">
    <mat-grid-list
      [cols]="gridListColumns"
      [rowHeight]="dynamicRowHeight"
      gutterSize="16px"
    >
      @for (prompt of dataSource; track prompt) {
      <mat-grid-tile>
        <mat-card class="prompt-card">
          <mat-card-header>
            <mat-card-title class="prompt-card-header">
              <div class="prompt-card-title-container">
                <div>{{ prompt.title }}</div>
              </div></mat-card-title
            >
          </mat-card-header>
          <mat-card-content class="prompt-card-content">
            {{ prompt.description | removeTitlePrefix : prompt.title }}
          </mat-card-content>
          <mat-card-actions class="prompt-card-actions">
            <button
              mat-flat-button
              type="button"
              [ngClass]="'prompt-card-button'"
              (click)="selectPrompt(prompt)"
              i18n="@@useTemplateButton"
            >
              Use template
            </button>
          </mat-card-actions>
        </mat-card>
      </mat-grid-tile>
      } @empty {
      <div class="no-prompts-message" i18n="@@noPromptsFoundMessage">
        No prompt templates found.
      </div>
      }</mat-grid-list
    >
  </div>
</div>
